const appConstant = {
  API_URL: 'https://myfiuweb-prod.psoft.aws.fiu.edu',
  APP_URL: 'http://localhost'
};

export const imageConstants = {
  height: 580,
  width: 1024,
  size: 2000000,
}

export const externalServices = {
  uacode: 'UA-9282160-1',
}

export default appConstant



// WEBPACK FOOTER //
// ./src/constants/app.js